export function getNextCursorPosition<T extends HTMLInputElement>(
  element: T,
  prevValue: string,
  nextValue: string,
): number | undefined {
  const cursorPosition = element.selectionStart;

  return cursorPosition !== null
    ? cursorPosition + (nextValue.length - prevValue.length)
    : undefined;
}
